"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("../../../constants/index.js");
var _index2 = require("../../../helpers/index.js");
var _index3 = require("../../../utils/index.js");
var stringField = _index2.formatters.stringField;
var refinementTypes = _index.eventFieldValues.refinementTypes;
var getSearchTemplate = function getSearchTemplate(_ref) {
  var term = _ref.term,
    refinementValue = _ref.refinementValue,
    _ref$isFirstSearch = _ref.isFirstSearch,
    isFirstSearch = _ref$isFirstSearch === void 0 ? true : _ref$isFirstSearch,
    _ref$autocomplete = _ref.autocomplete,
    autocomplete = _ref$autocomplete === void 0 ? false : _ref$autocomplete;
  var common = {
    _telus: {
      refinementType: isFirstSearch ? refinementTypes.ORIGINAL : refinementTypes.CHANGED,
      refinementValue: stringField(refinementValue)
    }
  };
  var autocompleteFields = {};
  if (autocomplete) {
    autocompleteFields = {
      _telus: {
        autocompleteInstances: {
          value: 1
        },
        autoCompleteValue: stringField(term)
      }
    };
  }
  return (0, _index3.mergeObjects)(autocompleteFields, common);
};
var _default = exports["default"] = getSearchTemplate;